import { createActionGroup, props } from '@ngrx/store';
import { DoctorCatalogEntity } from '../../../../entities/mdqx/doctor/doctor-catalog.entity';
import { MutationChangeDoctorcatalogArgs, MutationCreateDoctorcatalogArgs, MutationDeleteDoctorcatalogArgs } from '../../../../mdqx-graphql-types';

export const DoctorCatalogActions = createActionGroup({
    source: 'doctorCatalog',
    events: {
        'Load Success': props<{ Payload: DoctorCatalogEntity[] }>(),
        'Load Request': props<{ Payload?: {} /*todo*/ }>(),
        'Load Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        // 'Create Request': props<{ Payload: MutationCreateDoctorcatalogArgs }>(),
        'Create Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Create Success': props<{ Payload: DoctorCatalogEntity[] }>(),

        'Change Request': props<{ Payload: MutationChangeDoctorcatalogArgs }>(),
        'Change Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Change Success': props<{ Payload: DoctorCatalogEntity }>(),

        'delete Request': props<{ Payload: MutationDeleteDoctorcatalogArgs }>(),
        'delete Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'delete Success': props<{ Payload: number }>(),
    },
});
